import { useEffect } from "react";
import { useStyles } from "@/styles/useStyles";
import { useStore } from "@/store";

export function Confetti() {
  const { theme } = useStyles();
  const showConfetti = useStore((state) => state.experience.showConfetti);
  const setShowConfetti = useStore((state) => state.experience.setShowConfetti);
  const badgeConfetti = useStore((state) => state.experience.badgeConfetti);
  const setBadgeConfetti = useStore(
    (state) => state.experience.setBadgeConfetti,
  );

  // Handle badge level-up confetti
  useEffect(() => {
    if (badgeConfetti) {
      const { x, y } = badgeConfetti;

      const badgeColors = [
        theme.colors.primary[6],
        theme.colors.primary[8],
        theme.colors.secondary[6],
        theme.colors.primary[7],
        theme.colors.secondary[4],
      ];

      const badgeDefaults = {
        origin: { x, y },
        shapes: ["star", "circle"],
        spread: 30,
        count: 30,
        startVelocity: 45,
        gravity: 0.8,
        decay: 0.94,
        scalar: 1.2,
      };

      async function fireBadgeConfetti(opts: any) {
        try {
          // @ts-expect-error confetti is not typed
          await confetti(Object.assign({}, badgeDefaults, opts));
        } catch (error) {
          console.error("Error firing badge confetti:", error);
        }
      }

      // Fire multiple bursts from the badge position
      const badgeConfigs = [
        { angle: 90, timeout: 0 },
        { angle: 75, timeout: 50 },
        { angle: 105, timeout: 100 },
        { angle: 60, timeout: 150 },
        { angle: 120, timeout: 200 },
      ];

      // Clear the state first to allow re-triggering
      setBadgeConfetti(null);

      setTimeout(async () => {
        for (let index = 0; index < badgeConfigs.length; index++) {
          const config = badgeConfigs[index];
          setTimeout(async () => {
            fireBadgeConfetti({
              ...config,
              colors: [badgeColors[index % badgeColors.length]],
            });
          }, config.timeout);
        }
      }, 100);
    }
  }, [
    badgeConfetti,
    theme.colors.primary,
    theme.colors.secondary,
    setBadgeConfetti,
  ]);

  // this should be run only once per application lifetime
  useEffect(() => {
    const colors = [
      theme.colors.primary[2],
      theme.colors.secondary[4],
      theme.colors.primary[6],
      theme.colors.secondary[8],
      theme.colors.primary[9],
      theme.colors.primary[8],
      theme.colors.secondary[6],
      theme.colors.primary[4],
      theme.colors.secondary[2],
    ];

    const defaults = {
      position: { y: 100 },
      shapes: ["circle"],
      spread: 20,
      count: 100,
      startVelocity: 100,
      // colors,
    };

    async function fire(opts: any) {
      // @ts-expect-error confetti is not typed
      await confetti(Object.assign({}, defaults, opts));
    }

    const configs = [
      // {
      //   angle: 150,
      //   timeout: 0,
      // },
      {
        angle: 110,
        timeout: 0,
      },
      {
        angle: 110,
        timeout: 200,
      },
      {
        angle: 100,
        timeout: 400,
      },
      {
        angle: 90,
        timeout: 500,
      },
      {
        angle: 80,
        timeout: 400,
      },
      {
        angle: 70,
        timeout: 200,
      },
      {
        angle: 60,
        timeout: 0,
      },
      // {
      //   angle: 30,
      //   timeout: 0,
      // },
    ];

    if (showConfetti) {
      setTimeout(async () => {
        for (let index = 0; index < configs.length; index++) {
          const config = configs[index];
          setTimeout(async () => {
            fire({ ...config, colors: [colors[index]] });
          }, config.timeout);
        }
      }, 300);

      setShowConfetti(false);
    }
  }, [
    theme.colors.primary,
    theme.colors.secondary,
    showConfetti,
    setShowConfetti,
  ]);

  return null;
}
